{
  "name": "@ns/public-ledger-auto-payments-resign-allowance",
  "version": "1.1.0",
  "description": "The company's allowance to its operating account is missing on the public ledger, so automatic top-ups have paused (#25 phase 4). Claimable by the company's public ledger signatories; one open per company. The holder proposes the same maximum allowance again (public-ledger/autopay/resign), which completes the card proposed; every signatory then signs it, paid by nodeStream's platform account, like set-up (DECISION 4.1, settled 2026-10-27).",
  "inputs": {},
  "outcomes": {
    "proposed": {
      "serverOnly": true
    },
    "stopped": {
      "serverOnly": true
    }
  }
}
